import { array, number, object, string } from 'yup'
import { stringify } from 'src/core/hooks/use-translation'
import { Service, StandardType } from 'src/types'

function isNotKmService(service: Service) {
  return service?.standard_type !== StandardType.KM
}
interface Props {
  kmNeedJustification: boolean
}

export const getValidationSchema = ({ kmNeedJustification }: Props) =>
  object().shape({
    request_ticket_receipts: array()
      .of(
        object().shape({
          amount: number().when('service', {
            is: isNotKmService,
            then: number().min(
              0.01,
              stringify('common.yup.field-min-value', { value: 0.01 })
            )
          }),
          currency_id: string().required(),
          date: number().required(),
          payment_resource_id: string().required().typeError(),
          exchange_rate: number().when('service', {
            is: isNotKmService,
            then: number().min(
              0.01,
              stringify('common.yup.field-min-value', { value: 0.01 })
            )
          }),
          quantity: number().when('service', {
            is: (service: Service) =>
              service?.standard_type === StandardType.KM,
            then: number().min(
              0.01,
              stringify('common.yup.field-min-value', { value: 0.01 })
            )
          }),
          reference_id: string().required().typeError(),
          service_id: string().required().typeError(),
          justification: string().when('service', {
            is: (service: Service) =>
              kmNeedJustification && service?.standard_type === StandardType.KM,
            then: string().required()
          })
        })
      )
      .required(),
    request_ticket_user_data: array().of(
      object().shape({
        traveler: object().shape({
          user_id: string().required()
        })
      })
    )
  })
